import type { ReactNode } from "react";

export interface WebNavigationItem<T extends string> {
  readonly id: T;
  readonly label: string;
  readonly icon: string;
}

/** Shared semantic shell; apps provide their own registered navigation and theme. */
export function WebAppShell<T extends string>({
  displayName,
  active,
  items,
  onSelect,
  headerAction,
  children,
}: {
  readonly displayName: string;
  readonly active: T;
  readonly items: readonly WebNavigationItem<T>[];
  readonly onSelect: (id: T) => void;
  readonly headerAction: ReactNode;
  readonly children: ReactNode;
}): JSX.Element {
  return <div className="app">
    <header className="topbar">
      <button className="brand" onClick={() => onSelect(items[0]!.id)} aria-label={`${displayName} ${items[0]!.label}`}><span>₩</span>{displayName}</button>
      <nav aria-label={`${displayName} 메뉴`}>
        {items.map((item) => <button key={item.id} className={active === item.id ? "active" : ""} onClick={() => onSelect(item.id)}>{item.label}</button>)}
      </nav>
      <div className="header-actions">{headerAction}</div>
    </header>
    <main>{children}</main>
    <nav className="mobile-nav" aria-label={`${displayName} 모바일 메뉴`}>
      {items.map((item) => <button key={item.id} className={active === item.id ? "active" : ""} onClick={() => onSelect(item.id)}><b>{item.icon}</b><span>{item.label}</span></button>)}
    </nav>
  </div>;
}
